import { useQuery } from "@tanstack/react-query";

const PLAID_SESSION_TOKEN_STALE_TIME_MS = 10 * 60 * 1000; // 10 minutes

interface PlaidSessionTokenResponse {
  link_token: string;
}

async function createPlaidSessionToken(): Promise<PlaidSessionTokenResponse> {
  const response = await fetch(
    `${import.meta.env.VITE_PUBLIC_API_URL}/v1/signed_urls/plaid/session_token/`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) {
    throw new Error(`Failed to create Plaid session token: ${response.status}`);
  }
  return response.json() as Promise<PlaidSessionTokenResponse>;
}

function useCreatePlaidSessionToken({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["plaidSessionToken"],
    queryFn: createPlaidSessionToken,
    enabled,
    retry: 2,
    staleTime: PLAID_SESSION_TOKEN_STALE_TIME_MS,
  });
}

export { useCreatePlaidSessionToken };
